module.exports = __webpack_public_path__ + "static/img/acceptance.6b3b1b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/acceptance.png
// module id = 3LcN
// module chunks = 1